import * as React from 'react';
import { connect } from 'react-redux';
import Container from '@material-ui/core/Container';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { styled } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from '../../theme';
import Footer from '../../shared/components/Footer';
import Cover from '../components/event/Cover';
import PreviewNotice from '../components/PreviewNotice';
import Guide from '../components/event/Guide';
import ErrorBoundary from '../../shared/components/ErrorBoundaryJobseeker';

const AppBackdrop = styled(Backdrop)( (theme) => (
  {
      zIndex: 1000, //theme.zIndex.drawer + 1,
      color: '#fff',
  }
));

const AppContainer = styled(Container)( (props) => (
  {
    backgroundColor: props.theme.palette.background.default,
    minHeight: `calc( 100vh - ${props.theme.footerHeight + 52}px )`,
    [theme.breakpoints.down('xs')]: {
      minHeight: `calc( 100vh - ${props.theme.footerHeight + 52 + 56}px )`, // 56 android bar
    }
  }
));

class App extends React.Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <Cover backgroundURL={this.props.backgroundURL}>
          { window.appConfig.preview ? <PreviewNotice /> : '' }
          <AppContainer style={ this.props.backgroundURL ? {backgroundColor: 'transparent'} : {} }>
            <ErrorBoundary>
              {this.props.children}
            </ErrorBoundary>
          </AppContainer>
        </Cover>
        { this.props.backgroundURL ? <Guide /> : '' }
        <Footer hideXS={this.props.isChat} />
        <AppBackdrop open={this.props.backdropOpen}>
          <CircularProgress color="inherit" />
        </AppBackdrop>
      </ThemeProvider>
      );
  }
}

const mapStateToProps = state => {
  return {
    isChat: state.router.location && state.router.location.pathname.endsWith('chat'),
    backdropOpen: state.app.loading,
    backgroundURL: state.event && state.event.bg && state.event.data.background ? state.event.data.background.cover.url : null,
  }
}

const mapDispatchToProps = dispatch => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
